var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"filesystem-manage"},[_c('div',{staticClass:"outlet-viewer"},[_c('Transition',{attrs:{"appear":"","name":"fade","mode":_vm.simultaneous ? '': 'out-in'}},[_c('RouterView')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }